module.exports = {
    "name": "",
    "url": "",
    "imageUrl": "",
    "type": "more_items"
};
